var React = require('react');

function IconEditAssociation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3","key":0}),React.createElement("line",{"x1":"8","y1":"12","x2":"16","y2":"12","key":1})]);
}

IconEditAssociation.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-link-2"};

module.exports = IconEditAssociation;

IconEditAssociation.default = IconEditAssociation;
